export default {
	product: 1,
	rawmaterial: 2
}